import React from 'react';
import { FixedSizeList as List } from 'react-window';
import styles from './VirtualFriendsList.module.css';
import { HiUserCircle, HiTrash, HiCheckCircle, HiXCircle } from 'react-icons/hi2';
import avatarFallback from './../../../assets/default-avatar.svg';
import Button from '../../ui/Button';

const MAX_HEIGHT = 200;

export default function VirtualFriendsList({ friends, onUnfollow, onView, onRemove, onAccept, onDecline }) {
  if (!friends || friends.length === 0) {
    return (
      <div className={styles.empty}>
        <p>No friends found.</p>
        <p>Try searching or connecting with users in debates!</p>
      </div>
    );
  }

  const Row = ({ index, style }) => {
    const friend = friends[index];
    return (
      <div className={styles.row} style={style}>
        <img src={friend.profilePicture || avatarFallback}  alt={`${friend.username} avatar`} className={styles.avatar} onError={(e) => (e.target.src = avatarFallback)}/>
        <div className={styles.name}>{friend.username}</div>
        <div className={styles.actions}>
          {onView != null ? <Button onClick={(e) => onView(friend.uid, e)} title="View Profile">
            <HiUserCircle />
          </Button> : <></>}
          {onRemove != null ? <Button onClick={() => onRemove(friend.uid)} title="Remove Friend">
            <HiTrash />
          </Button> : <></>}
		  {onAccept != null ? <Button onClick={() => onAccept(friend.uid)}  title="Accept Friend">
			<HiCheckCircle />
		  </Button> : <></>}
		  {onDecline != null ? <Button onClick={() => onDecline(friend.uid)} title="Decline Friend">
			<HiXCircle />
		   </Button> : <></>}
          {onUnfollow != null ? <Button onClick={() => onUnfollow(friend.uid)} title="unfollow Friend">
            <HiTrash />
           </Button> : <></>}
        </div>
      </div>
    );
  };

  return (
    <List
      className={styles.list}
      height={Math.min(friends.length * 72, MAX_HEIGHT)}
      itemCount={friends.length}
      itemSize={72}
      width="100%">
      {Row}
    </List>
  );
}
